import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=13a3fe2d&scoped=true&"
import script from "./CheckboxGroup.vue?vue&type=script&lang=ts&"
export * from "./CheckboxGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a3fe2d",
  null
  
)

export default component.exports